var _rect, _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBrandTikTok(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    rx: 10,
    fill: "#010101"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M33.5 15.9a7.9 7.9 0 0 1-4.86-1.64 7.9 7.9 0 0 1-1.98-2.31 7.7 7.7 0 0 1-.99-2.55h-4.02v18.03c0 .68 0 1.36-.03 2.03a4.02 4.02 0 0 1-2.9 3.72 4.03 4.03 0 0 1-4.9-2.32 4.02 4.02 0 0 1 3.2-5.48c.43-.06.86-.05 1.29 0v-4.09a8.13 8.13 0 0 0-6.86 2.02 8.12 8.12 0 0 0-2.5 4.62 8.13 8.13 0 0 0 1.63 6.38 8.12 8.12 0 0 0 5.8 3.05 8.13 8.13 0 0 0 8.53-6.02c.22-.86.28-1.73.28-2.61l-.02-8.86a11.8 11.8 0 0 0 6.32 1.83v-4.03c-.26.02-.52.02-.79 0Z",
    fill: "#FFFFFF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M31.9 14.26a7.9 7.9 0 0 1-1.24-1.16 7.9 7.9 0 0 1-1.98-2.31c.44 1.5 1.35 2.78 2.62 3.66.2.14.4.27.6.38a7.94 7.94 0 0 0 1.8.71v-.04a7.9 7.9 0 0 1-1.8-1.24Z",
    fill: "#25F4EE"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.62 21.7a8.13 8.13 0 0 0-6.86 2.02 8.12 8.12 0 0 0-2.5 4.62c-.2 1.13-.14 2.28.16 3.38a8.12 8.12 0 0 1 2.34-3.9 8.13 8.13 0 0 1 6.86-2.02v-4.1Z",
    fill: "#25F4EE"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M34.29 15.9v4.03a11.8 11.8 0 0 1-6.32-1.83l.02 8.86c0 .88-.06 1.75-.28 2.61a8.13 8.13 0 0 1-8.53 6.02c.36.04.72.06 1.09.06a8.13 8.13 0 0 0 7.72-6.08c.22-.86.28-1.73.28-2.61l-.02-8.86a11.8 11.8 0 0 0 6.32 1.83V15.9c-.09.01-.18.01-.27 0Z",
    fill: "#FE2C55"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M18.62 25.8v-.02a4.02 4.02 0 0 0-4.19 2.32 4.02 4.02 0 0 0 .99 4.66 4.02 4.02 0 0 1 3.2-6.96Z",
    fill: "#FE2C55"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBrandTikTok);
export default __webpack_public_path__ + "static/media/Brand-TikTok.9ee509607cf280d06f9a2994382ace5b.svg";
export { ForwardRef as ReactComponent };